import { coach } from '../jsonEditor/coachJsonEditorConfig.js';
import { statusConfig } from '../options.js';
export const coaches = {
    type: 'coaches',
    contentType: 'coach',
    editor: 'json',
    editorConfig: coach,
    editorContext: 'root',
    supportContent: ['categories'],
    title: 'Coach',
    plural: 'Coaches',
    endpoint: 'coaches',
    listing: {
        type: 'grid',
        gridColumns: ['name'],
        gridContentType: 'coaches',
        gridDecode: ['name'],
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
        ],
        gridHasChildren: true,
        gridJoin: { properties: [] },
        gridSearch: [{ key: 'name', combine: false }],
        gridSupportContent: [],
    },
    queryProperties: ['id', 'name', 'status'],
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
        ],
        images: [
            { label: 'Coach Image', name: 'image' },
            { label: 'V3 Coach Image', name: 'v3image' },
            { label: 'V3 Index Image', name: 'v3indexImage' },
        ],
    },
    meta: [
        {
            label: 'Featured',
            name: 'isFeatured',
            input: 'select',
            description: 'Sets the coach as featured.',
            options: [
                { label: 'False', value: false },
                { label: 'True', value: true },
            ],
        },
        {
            label: 'Legacy ID',
            name: '_legacyId',
            input: 'number',
            description: 'Legacy ID for the document (if applicable).',
        },
    ],
    validate: [],
};
//# sourceMappingURL=coaches.js.map